import { ReactNode } from 'react';

import { ChakraProvider, SystemContext } from '@chakra-ui/react';

import { raspberrySsrTheme } from '@nocowanie/common-ui';

const ThemeProvider = ({
    theme,
    children,
}: {
    theme?: SystemContext;
    children: ReactNode;
}): ReactNode => {
    return <ChakraProvider value={theme ?? raspberrySsrTheme}>{children}</ChakraProvider>;
};

export default ThemeProvider;
